<template>
  <div id="app">

    <router-view/>
     
    
  </div>
</template>

<script>
//import NavBottom from './components/Nav/NavBottom'
import "@pwabuilder/pwainstall";
export default {
    
  methods: {
    install(){
    var installComponent = document.getElementById("pwa-install");
    document.body.appendChild(installComponent);
    installComponent.getInstalledStatus();
    console.log(installComponent.getInstalledStatus())
    },
   
  },

}
</script>

<style>
@import './assets/css/reset.css';
@import './assets/css/theme.css';
@import './assets/css/style.css';
@import './assets/css/responsive.css';
@import './assets/css/ui.css';
@import './assets/css/bootstrap.css';
</style>